import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="796.686"
      height="1828.574"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 796.686 1828.574"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1873.861 -146.046)"
      >
        <path
          strokeWidth="3"
          d="M2231.67 150.287c-12.28 2.193-26.31 6.579-42.1 13.157-15.79 6.579-28.29 13.157-37.5 19.736-9.21 6.578-17.32 13.376-24.34 20.393-7.01 7.017-13.37 14.473-19.07 22.367-5.71 7.895-11.19 17.104-16.45 27.63s-9.65 22.148-13.16 34.866c-3.51 12.719-5.7 29.165-6.58 49.339-.87 20.175-.44 35.744 1.32 46.708 1.75 10.964.66 19.297-3.29 24.999-3.95 5.701-6.36 11.841-7.24 18.419-.87 6.579 1.98 18.859 8.56 36.84 6.57 17.982 12.28 28.946 17.1 32.893 4.82 3.947 10.09 6.798 15.79 8.552 5.7 1.754 11.4 6.798 17.1 15.131 5.7 8.332 11.4 15.35 17.11 21.051 5.7 5.701 12.71 11.403 21.05 17.104a153.57 153.57 0 0026.31 14.473c9.21 3.947 14.26 7.675 15.13 11.183.88 3.509 2.63 7.018 5.27 10.526 2.63 3.509 5.26 5.921 7.89 7.237 2.63 1.315 11.4 3.289 26.31 5.92 14.92 2.632 24.13 3.289 27.63 1.974 3.51-1.316 7.02-4.167 10.53-8.552 3.51-4.386 5.04-9.868 4.6-16.447-.43-6.578-2.19-11.622-5.26-15.13-3.07-3.509-11.4-7.017-25-10.526-13.59-3.509-22.58-5.263-26.97-5.263-4.38 0-8.77 1.535-13.16 4.605-4.38 3.07-8.11 4.605-11.18 4.605-3.07 0-10.96-3.728-23.68-11.183-12.72-7.456-23.69-16.227-32.9-26.315-4.6-5.043-9.21-10.087-13.81-15.13l6.58-1.316c4.38-.877 6.36-3.07 5.92-6.578l-.66-5.263c1.97 1.535 3.95 3.07 5.92 4.605 3.95 3.07 8.33 4.166 13.16 3.289 4.82-.877 8.33-2.631 10.52-5.263 2.2-2.631 3.29-6.14 3.29-10.525 0-4.386-5.48-22.368-16.44-53.944-10.97-31.577-17.33-48.682-19.08-51.313-1.75-2.632-4.17-4.605-7.24-5.921-3.07-1.315-6.14-1.754-9.21-1.315-3.07.438-5.7 1.315-7.89 2.631-2.19 1.316-3.95 4.605-5.26 9.868l-1.98 7.894c-.44-.219-.87-.439-1.31-.658-.88-.438-2.41-5.701-4.61-15.788-2.19-10.087-3.51-20.832-3.94-32.235-.44-11.403.21-23.025 1.97-34.866 1.75-11.842 4.17-22.148 7.24-30.92 3.07-8.771 7.45-18.2 13.15-28.287s11.84-18.859 18.42-26.314c6.58-7.456 13.6-14.035 21.05-19.736 7.46-5.701 16.01-10.964 25.66-15.789 9.65-4.824 22.37-8.99 38.16-12.499 15.78-3.508 33.33-4.824 52.62-3.947 19.3.877 32.24 2.193 38.82 3.947 6.58 1.755 15.35 5.263 26.31 10.526 10.97 5.263 22.15 12.718 33.55 22.367 11.4 9.648 21.49 21.271 30.26 34.866 8.77 13.596 15.35 27.411 19.74 41.445 4.38 14.034 7.02 28.068 7.89 42.103.88 14.034.88 25.437 0 34.208-.87 8.771-2.41 16.227-4.6 22.367-1.1 3.07-2.2 6.14-3.29 9.21l-1.98-7.236c-1.31-4.825-3.72-8.333-7.23-10.526-3.51-2.193-7.02-3.07-10.53-2.631-3.51.438-6.58 1.754-9.21 3.947-2.63 2.192-9.86 19.955-21.71 53.286-11.84 33.331-17.76 51.751-17.76 55.26 0 3.508 1.1 6.797 3.29 9.867 2.19 3.07 4.39 5.044 6.58 5.921 2.19.877 5.26 1.096 9.21.658 3.95-.439 7.24-1.974 9.87-4.605 1.31-1.316 2.63-2.632 3.94-3.947-.21 1.754-.43 3.508-.65 5.263-.44 3.508-.22 5.482.65 5.92.88.439 5.27.658 13.16.658 7.9 0 16.01-1.316 24.34-3.947 8.33-2.631 14.69-5.921 19.08-9.868 4.39-3.947 7.24-7.236 8.55-9.868 1.32-2.631 4.17-10.306 8.55-23.024 4.39-12.719 6.8-22.148 7.24-28.288.44-6.14-1.75-13.815-6.58-23.025-4.82-9.21-6.14-21.929-3.95-38.156 2.2-16.227 2.42-32.892.66-49.996-1.75-17.105-4.82-32.016-9.21-44.735-4.38-12.718-10.52-25.656-18.42-38.813-7.89-13.157-17.54-25.437-28.94-36.84-11.41-11.403-23.9-21.051-37.5-28.945-13.6-7.895-29.17-14.254-46.71-19.078s-33.77-7.456-48.68-7.894c-14.91-.439-28.51.438-40.79 2.631z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2253.23 625.958c8.37 8.003 38.15 22.42 49.72 19.515 50.61-12.716 55.31-31.372 79.79-70.961"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2215.47 1475.91s43.71 219.86 28.12 328.22c-15.59 108.37-90.48 105.23-90.48 105.23"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2008.67 848.169s-14.91 132.987 2.66 170.371c17.58 37.39 53.88 55.06 53.88 55.06"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2264.74 1125.11s78.25 31.14 133.94 17.04c55.69-14.1 99.44-84.56 99.44-84.56"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2503 1056.11s49.14 11.83 84.13 4.23c34.98-7.61 61.49-43.22 61.49-43.22"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1953.61 870.463s14.09 29.562 49.07 21.953"
          opacity="1"
        ></path>
        <path
          strokeDasharray="5"
          strokeWidth="1"
          d="M1954.28 857.543s14.08 29.561 49.06 21.953"
          opacity="1"
        ></path>
        <path
          strokeDasharray="5"
          strokeWidth="1"
          d="M2653.36 984.51s-31.14 38.44-66.36 45.63c-35.22 7.19-65.66-.39-65.66-.39"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2180 600.573s-24.26 41.841 6.85 87.3c26.61 38.886 83.93 79.775 83.93 79.775s71.96-47.524 100.61-89.973c28.64-42.449 13.96-79.824 13.96-79.824"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2156.31 606.42s-23.17 37.576 3.7 91.949c26.88 54.373 105.11 124.535 105.11 124.535s80.91-58.938 118.26-109.055c37.36-50.118 30.98-98.328 30.98-98.328"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2116.13 379.591s.86-4.77.84-6.084c-.16-7.595-2.67-34.272 2.08-62.377 2.31-13.645 9.73-23.831 16.06-32.798 9.57-13.549 22.66-37.997 37.87-41.567 10.73-2.519 23.57-12.03 27.33-14.581 7.68-5.209 10.23-7.973 14.62-9.902 3.01-1.318 15.25-.538 20.25-2.795 5-2.257 21.88-7.644 28.86-8.936 6.62-1.226 15.04-2.193 20.74-1.568 12.79 1.401 35.17 8.425 47.63 13.494 9.63 3.916 20.33 14.554 27.61 19.456 3.67 2.469 8.53 3.949 15.17 8.126 3.31 2.084 7.94 4.572 11.25 8.905 6.7 8.773 14.93 29.107 17.34 35.722 4.36 11.965 3.02 30.791 5.73 42.938 5.74 25.776 16.1 43.471 16.71 63.456"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2405.61 511.404c-.46 11.185-1.04 22.183-3.21 30.79-1.72 6.818-4.7 11.569-7.47 17.72-7.34 16.329-12.34 24.412-10.49 35.615.05.257 2.22 7.931 10.72 12.027 6.92 3.335 15.32 3.993 25.76 8.562 46.5 20.341 118.37 52.424 121.59 53.839 12.3 5.401 26.54 12.737 37.55 20.242 2.59 1.769 10.02 6.454 18.39 13.063 6.77 5.357 14.17 12.265 20.1 17.624 7.23 6.544 18.87 13.92 25.61 23.439 13.35 18.865 19.2 47.269 22.72 78.567 3.41 30.382-1.44 70.521-5.06 108.637-1.78 18.665-10.21 65.204-13.25 84.981m-2.91 6.34c-5.42 29.8-23.04 124.65-28.99 148.79-4.62 18.74-10.26 40.98-14.71 61.69-2.75 12.78-8.41 40.13-11.57 50.98-11.47 39.45-23.26 72.51-39.13 109.71-6.42 15.06-10.63 22.77-15.29 38.39-4.27 14.3-8.04 29.48-11.65 39.67-10.06 28.49-15.21 28.33-19.55 44.71-4.1 15.46-2.76 32.91-5.43 46.64-5.32 27.32-12.25 43.1-30.89 64.55-13.44 15.47-33.12 27.96-50.01 36.18-42.51 20.69-88.59 2.92-80.34-9.41 5.98-8.93 16.41-4.73 24.59-12.77 9.55-9.39 15.35-20.7 15.35-20.7s-15.81 11.65-29.8 13.64c-11.26 1.6-21.08-5.73-22.51-10.05-3.21-9.68 10.24-4.51 21.13-25.33 10.89-20.81 13.27-40.89 26.1-60.89 25.09-39.09 57.89-59.56 57.89-59.56s20.86-43.55 38.13-113.51c17.28-69.97 22.38-119.08 30.98-166.35 6.1-33.55.72-42.16 2.58-77.42 1.86-35.26 4.86-63.64 4.86-63.64s-2.25-2.21-4.57-2.2c-2.32.01-4.71 2.25-4.71 2.25s-5.02 9.74-10 26.68c-3.04 10.33-6.9 23.71-7.17 38.11-.34 17.64 3.99 31.45 8.01 48.99 4.36 19.05 6.27 38.3 6.27 38.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2179.16 572.054c.1 7.253 1.76 14.633.85 28.18-8.44 2.399-20.34 1.925-43.12 11.285-1.45.597-6.17 1.582-13.3 1.773-2.22.06-5.45 6.599-8.91 9.481-4.54 3.774-22.64-4.223-28.82 3.345-2.96 3.622-4.41 7.057-7.58 11.464-2.24 3.12-20.42 4.837-24.75 7.224-4.32 2.386-14.55 10.627-16.97 14.542-.48.784-14.41.756-27.92 6.499-15.56 6.617-30.55 19.591-31.53 20.043-9.32 4.293-19.14 8.805-21.53 13.902-4.19 8.93-5.51 20.197-7.98 29.458-10.84 40.782-8.56 76.84-1.41 109.606 4.17 19.12 6.52 31.503 6.52 31.503"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1953.97 874.952c-.16 13.051 3.98 9.69.18 47.36-1.36 13.541-5.72 14.503-11.62 32.318-13.46 40.682-7.53 30.272-13.67 60.49-6.86 33.81-13.92 81.79-19.68 123.53-9.21 66.84-20.79 122.04-31.08 161.33-2.88 10.98-2.56 43.4 4.03 58.47 4.5 10.27 10.4 22.71 16.75 26.68 10.05 6.28 20.6.15 23.63-2.45 7.74-6.65 12.2-23.06 12.2-23.06s3.74.57 7.77 3.99c6.93 5.88 16.35 16.12 20.73 16.91 51.99 9.4 44.37-14.83 115.02 2.2s74.17 57.59 167.58 65.9c93.42 8.31 206.08-32.66 206.08-32.66"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2010.23 1054.95s-3.04 31.56-20.55 66.17c-9.53 18.86-36.93 57.1-43.59 83.86-18.87 75.9-11.34 153.56-11.34 153.56"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1946.57 1367.42s12.15 81.91 30.88 174.1c6.87 33.81 15.74 65.52 23.63 100.04 9.62 42.03 18.95 76.63 23.87 96.54 4.69 18.95 2.65 42.02 2.09 50.52-1.51 22.76-5.48 24.33-4.61 29.23 7.93 44.61 48.68 98.33 83.11 105.49"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2347.54 1669.2s-9.36 3.95-12.43 11.47c-6.86 16.82-15.54 39.83-25.97 59.29-3.78 7.06-3.17 7.84-4.23 11.85-2.32 8.77-7.7 19.3-12.58 30.41-6 13.64-13.09 27.43-16.34 37.31-2.04 6.2-3.57 11.77-4.72 13.91-2.5 4.63-5.78 12.03-9.38 17.3-40.74 59.6-82.47 58.2-82.47 58.2"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2021.04 1820.3s-6.75 9.75-12.93 40.52c-3.01 14.99-6.29 53.85-2.61 65.43 2.25 7.04 6.3 12.29 9.76 16.64 5.82 7.32 11.59 12.88 17.31 16.98 7.03 5.04 17.31 8.71 23.07 10.93 10.91 4.22 17.97 3.74 21.7 2.24 4.1-1.65 12.56-8.56 16.4-15.07 5.71-9.66 8.06-20.5 9.78-26.8.79-2.9 2.46-5.38 2.46-5.38"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1918.98 1347.96c-1.36.99-15.77 6.12-5.34 17.5 1.03 1.14 4.01-.6 5.4-3.96 1.74-4.19 1.29-14.53-.06-13.54z"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2265.1 822.316s2.7-13.959 4.08-27.256c1.39-13.296 1.46-25.93 1.46-25.93"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2145.18 503.49s6.24 11.234 11.96 15.792c1.11.889 4.55 1.455 6.09 1.575 2.1.166 2.04-.645 3.55.288 2.02 1.243 2.76 3.924 3.45 5.195 1.13 2.068 5.32 9.901 6.58 12.333 3.82 7.414 3.11 13.33 3.11 13.33"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2259.33 1858.77s-.1 3.24 1.45 8.17c1.46 4.67 3.8 9.93 7.44 17.04 2.5 4.88 5.26 10.11 7.41 14.49 1.96 4 4.99 9.95 6.2 14.27.85 3.01.42 5.25.42 5.25"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2499.11 1056.15s20.43-10.28 29.66-39.38c5.58-17.587 2.02-32.455 4.05-43.989 5.01-28.482 10.14-24.307 8.58-39.212"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;